import { DocumentNode, gql } from "@apollo/client";

export interface MarkOrderAsAccessedByPatientResponse {
  success: boolean;
}

export default class SimpleOrderService {
  public static completeSimpleOrder = (): DocumentNode => gql`
    mutation CompleteSimpleOrder(
      $orderUidPublic: String!
      $workflowUid: String!
      $simpleOrderInfo: SimpleOrderCompleteDTO!
      $testName: String!
      $limsClinicId: String!
    ) {
      completeSimpleOrder(
        orderUidPublic: $orderUidPublic
        workflowUid: $workflowUid
        simpleOrderInfo: $simpleOrderInfo
        testName: $testName
        limsClinicId: $limsClinicId
      ) {
        uid
      }
    }
  `;

  public static cancelSimpleOrder = (): DocumentNode => gql`
    mutation CancelSimpleOrder(
      $orderUidPublic: String!
      $testName: String!
      $limsClinicId: String!
    ) {
      cancelSimpleOrder(
        orderUidPublic: $orderUidPublic
        testName: $testName
        limsClinicId: $limsClinicId
      ) {
        success
      }
    }
  `;

  public static markOrderAsAccessedByPatient = (): DocumentNode => gql`
    mutation MarkOrderAsAccessedByPatient(
      $orderUidPublic: String!
      $workflowUid: String!
      $testName: String!
      $limsClinicId: String!
    ) {
      markOrderAsAccessedByPatient(
        orderUidPublic: $orderUidPublic
        workflowUid: $workflowUid
        testName: $testName
        limsClinicId: $limsClinicId
      ) {
        success
      }
    }
  `;
}
